// Module
var code = `<div class="overlay"></div>
<div class="header">
  <div class="back-button"></div>
  <div class="title">\${title}</div>
  <!-- <hs-title></hs-title> -->
</div>
`;
// Exports
export default code;